module.exports = __webpack_public_path__ + "img/21 Aniamtion 3-squashed.c8737099.jpg";